import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import bnTranslations from './locales/bn.json';
import enTranslations from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      bn: {
        translation: bnTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    fallbackLng: 'en', // English as default
    lng: localStorage.getItem('language') || 'en', // Default language English
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
